import { Component, NgZone, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { setTheme } from 'ngx-bootstrap/utils';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './core/auth/auth.service';
import { NotificationService } from './shared/services/notification.service';
import { Title } from '@angular/platform-browser';
import { LineUpProNotification } from './shared/DTOs/lineupProNotification';
import { environment } from "../environments/environment";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent implements OnInit
{
  message:any = null;
    /**
     * Constructor
     */
    constructor(private notificationService: NotificationService,
                private zone: NgZone,
                public snackBar: MatSnackBar,
                private _authService: AuthService,
                private router: Router,
                private titleService: Title,
                )
    {
      // setTheme('bs5');
    }

    ngOnInit() {
      this.requestPermission();
      this.listen();
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          // Logic to handle refresh
          this._authService.refreshPage();
          // Set the title dynamically based on the route
          const title = this.getTitle(this.router.routerState, this.router.routerState.root).join(' - ');
          this.titleService.setTitle(`LineUp Pro - ${title}`);
        }
      });

      this.notificationService.getNotification().subscribe((notification: LineUpProNotification) => {
        if (notification) {
          if (notification.pinned) {
            this.zone.run(() => {
              this.snackBar.open(notification.message, 'Close', notification.options);
            });
          } else {
            this.zone.run(() => {
              this.snackBar.open(notification.message, '', notification.options);
            });
          }
        } else {
          this.snackBar.dismiss();
        }
      }, error => {
        console.log(error);
      });
      }

        // Recursive function to get titles from activated route
        getTitle(state, parent) {
          const data = [];
          if (parent && parent.snapshot.data && parent.snapshot.data.title) {
            data.push(parent.snapshot.data.title);
          }

          if (state && parent) {
            data.push(...this.getTitle(state, state.firstChild(parent)));
          }

          return data;
        }

        requestPermission() {
          // Get messaging instance
          const messaging = getMessaging();
              
          // Solicitar permissão para obter o token FCM
          getToken(messaging, { vapidKey: environment.firebase.vapidKey })
              .then((currentToken) => {
                  if (currentToken) {
                      console.log("Token obtido:", currentToken);
                      localStorage.setItem('device-token', currentToken)
                  } else {
                      console.log('Nenhum token de registro disponível. Solicite permissão para gerar um.');
                  }
              })
              .catch((err) => {
                  console.log('Erro ao recuperar o token: ', err);
              });
      }

      
      listen() {
          // Get messaging instance
          const messaging = getMessaging();
      
          // Set up listener for incoming messages
          onMessage(messaging, (payload) => {
            console.log('Message received in foreground: ', payload);

            // Create a notification
            const notificationTitle = payload.notification.title;
            const notificationOptions = {
              body: payload.notification.body,
              icon: payload.notification.icon,
              requireInteraction: true,  // This will prevent the notification from closing automatically
            };
      
            // Show the notification
            if (Notification.permission === 'granted') {
              new Notification(notificationTitle, notificationOptions);
            } else {
              console.log('Notification permission is not granted');
            }
          });

          
      }
      
}
